// Utility for domain redirects (disabled)
export const handleDomainRedirect = () => {
  return false;
};

if (typeof window !== 'undefined') {
  handleDomainRedirect();
}
//test